import { Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { ImageModule } from 'primeng/image';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuProfileComponent } from './app.menuprofile.component';
import { LayoutService } from './service/app.layout.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
  imports: [AppMenuComponent, AppMenuProfileComponent, ImageModule],
})
export class AppSidebarComponent implements OnDestroy {
  private readonly layoutService = inject(LayoutService);

  public readonly el = inject(ElementRef);

  // eslint-disable-next-line no-undef
  private timeout: NodeJS.Timeout | null = null;

  @ViewChild(AppMenuProfileComponent) public menuProfile!: AppMenuProfileComponent;

  @ViewChild('menuContainer') public menuContainer!: ElementRef;

  protected resetOverlay(): void {
    if (this.layoutService.state.overlayMenuActive) {
      this.layoutService.state.overlayMenuActive = false;
    }
  }

  protected get menuProfilePosition(): string {
    return this.layoutService.config().menuProfilePosition;
  }

  protected onMouseEnter(): void {
    if (!this.layoutService.state.anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.layoutService.state.sidebarActive = true;
    }
  }

  protected onMouseLeave(): void {
    if (this.layoutService.state.anchored) {
      return;
    }

    if (!this.timeout) {
      this.timeout = setTimeout(() => {
        this.layoutService.state.sidebarActive = false;
      }, 300);
    }
  }

  protected anchor(): void {
    this.layoutService.state.anchored = !this.layoutService.state.anchored;
  }

  public ngOnDestroy(): void {
    this.resetOverlay();
  }
}
